import { render, staticRenderFns } from "./others.vue?vue&type=template&id=05381d51"
import script from "./others.vue?vue&type=script&lang=js"
export * from "./others.vue?vue&type=script&lang=js"
import style0 from "./others.vue?vue&type=style&index=0&id=05381d51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports